import React, {useContext} from "react";
import { useTranslation } from 'react-i18next';

import Paper from "@/components/paper/Paper";
import Cards from "@/components/multipleCards/Cards";
import { isNotUndefined } from "@/shared/FunctionCore";
import { AppContext, ContextType } from "@/shared/context";

const CreditReports = ({countryCode}): JSX.Element => {
  const { isUnitedStates } = useContext(AppContext) as ContextType
  const { t } = useTranslation();
  const cardsData = t("companyProfile.creditReport.creditReportsEntries", { returnObjects: true });
  
  const description = t("companyProfile.creditReport.description");
  // const seeAllText = properties!["seeAllText"];

  // if (typeof seeAllLinkPath !== "string") {
  //   throw new Error("typeof props.seeAllLinkPath is not string");
  // }

  // const hideCreditReports = isNotUndefined(country) && isNotUndefined(locale) && country !== canadaIsoCode && country !== unitedStatesIsoCode;

  const hideCreditReports = false;

  return (
    <>
      {hideCreditReports ? (
        <></>
      ) : (
                <>
                 <a
                  className="anchor"
                  data-name="credit-reports-anchor"
                  href="/credit-reports-anchor">
                    <span className="display-hidden">credit-reports</span>
                  </a>
                <Paper
                  title={t('companyProfile.creditReport.headingText')}
                  additionalContainerClass="business-directory-credit-reports credit-reports-parent"
                >
                <div className="details font-roman">
                  <span>
                    {description}
                  </span>

                  {isUnitedStates ?
                    <span className="need-more-link font-roman">
                      <a href={t('companyProfile.creditReport.seeAllLinkPath')}>
                        {t('companyProfile.creditReport.seeAllText')}

                        <span className="chevron-right-arrow-blue" />
                      </a>
                    </span> : <></>}
                </div>

                <Cards 
                  businessCreditReportProductCaUrl = {t('companyProfile.creditReport.businessCreditReportProductCaUrl')}
                  creditReportsEntries = {cardsData}
                  suppress_credit_report_product_link_with_text = {t('companyProfile.creditReport.suppress_credit_report_product_link_with_text')} />

                {isUnitedStates && (
                  <div className="need-more-mobile-link font-roman">
                    <a href={t('companyProfile.creditReport.seeAllLinkPath')}>
                        {t('companyProfile.creditReport.seeAllText')}
                        <span className="chevron-right-arrow-blue" />
                      </a>
                  </div>
                )} 
              </Paper> </>
      )}
    </>
  );
};

export default CreditReports;
